import React, { Component, lazy, Suspense } from 'react';
import { createHashHistory } from 'history';
import { Switch, Redirect, Route } from "react-router-dom";
//AppLandingPage
//Login Module
import Auth from "../../../../Layout/Auth";
import ChatList from '../Pages/ChatList';
// import ChatHistoryPage from '../Pages/ChatHistoryPage';
import NotFoundPage from '../../../../Utility/Pages/NotFound';

const ChatHistoryPage = lazy(() => import('../Pages/ChatHistoryPage'))


class ChatRoute extends Component {
    render() {
        const history = createHashHistory();
        const { allowedRoles } = this.props;
        return (

            <Switch>

                {/*****************Login Module Start****************/}


                <Route
                    exact
                    path="/:lng/chat"
                    render={() => (
                        <Auth history={history} allowedRoles={allowedRoles}>
                            <Suspense fallback={<Loading />}>
                                <ChatHistoryPage history={history} location={location} />
                            </Suspense>

                        </Auth>
                    )}
                />


                {/* <Route component={NotFoundPage} /> */}

            </Switch>
        );
    }
}
export default ChatRoute;

function Loading() {
    return (
      <>
        <div className="wrapper">
          <span>Loading...</span>
        </div>
      </>
    );
}
